import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import { Card, FormGroup, Alert, CardBody, CardTitle } from "reactstrap";
import Box from '@mui/material/Box';
// import Typography from "@mui/material/Typography";
import Collapse from '@mui/material/Collapse';
import { viewKycDetails } from "../../redux/actions/viewKycDetailsAction";
import {
	resetGetCustomerDetails,
	getCustomerDetails
} from "../../redux/actions/getCustomerDetailsAction";
import { makeStyles } from "@mui/styles";
import {
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	Accordion,
	AccordionSummary,
	AccordionDetails,Typography
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import GetAppIcon from '@mui/icons-material/GetApp'

// import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
// import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import {
	getKycApproveRejects,
	resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import ClearIcon from "@mui/icons-material/Clear";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { ExpandMore } from "@mui/icons-material";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";

const useRowStyles = makeStyles({
	root: {
		"& > *": {
			// borderBottom: "unset",
		}
	}
});

function PartnerViewKycDetails() {
	const location = useLocation();

	const [open, setOpen] = React.useState(false);
	const [viewKycDetailsStatus, setViewKycDetailsStatus] = useState(false);
	const [viewKycDetailsArray, setViewKycDetailsArray] = useState([]);

	const classes = useRowStyles();
	const verificationId = location.state.param1;
	const customerId = location.state.param2;
	// const action=location.state.param3;

	console.log(customerId);
	const dispatch = useDispatch();

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const viewKycDetailsRes = useSelector(({ viewKycDetails }) => viewKycDetails);

	const setViewKycDetailsStatusFunc = () => {
		setViewKycDetailsStatus(true);
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				verificationId: verificationId,
				customerId: customerId
			}
		};

		return dispatch(viewKycDetails(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setViewKycDetailsStatusFunc();
		}
	}, [customerId, regenerateTokenRes.data.status]);

	console.log(viewKycDetailsRes, "viewKycDetailsRes");

	const viewKycDetailsStatusFunc = () => {
		if (viewKycDetailsStatus) {
			if (viewKycDetailsRes.data.status == "success") {
				setViewKycDetailsArray(viewKycDetailsRes.data);
				// setViewKycDetailsArray(obj);
			}
			if (viewKycDetailsRes.data.status == "failed") {
				setViewKycDetailsArray(viewKycDetailsRes.data);
				if (
					viewKycDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					viewKycDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		viewKycDetailsStatusFunc();
	}, [viewKycDetailsRes.data.status]);

	const handleAcceptOrRejectReq = (
		verificationId,
		customerId,
		userRole,
		fileName,
		action,
		personId,
		recommendation
	) => {
		const acceptOrRejectReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				recommendation: recommendation,
				action: action,
				customerId: customerId,
				personId: personId,
				regFraudId: verificationId,
				fileName: fileName,
				role: userRole
			}
		};
		return dispatch(getKycApproveRejects(acceptOrRejectReq, authToken));
	};

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: ""
					}}
				>
					<div style={{ marginBottom: "1.5rem" }}
					
					>
						<Alert
							className="text-center tableHeaderColor"
							variant="secondary"
							// fullWidth={true}
							style={{ borderRadius: "0" }}
						>
							<Typography variant="body1"
								className="tableHeaderTextColor"
							>KYC Details</Typography>
						</Alert>
					</div>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}
					
					> 
						<div
							style={{
								marginTop: "2rem"
							}}
							
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Registration Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Parent ID:</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.customerId
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.customerId
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Role:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.userRole
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.userRole
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Entity Type:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.entityType
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.entityType
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Created By:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.initiatedBy
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.initiatedBy
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Modified By:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.modifiedBy
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.modifiedBy
													: "-"}
											</Col>
										</Row>
									</Col>
								</AccordionDetails>
							</Accordion>
						</div>
						{/* <Typography
              variant="h6"
              component="div"
              className=""
              style={{
                // fontSize: "1.4rem",
                color: "#013c83",
              }}
            >
              Registration Details
            </Typography> */}
						{/* <Row>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Parent ID:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.kycDetailList &&
                      viewKycDetailsArray.kycDetailList.customerId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Role:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.userRole}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Entity Type:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.entityType}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Created By:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.initiatedBy}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Modified By:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .initiatedBy}
                  </Col>
                </Row>
              </Col>
            </Row> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Verification Registration Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Action</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.action &&
													[]
														.concat(viewKycDetailsArray.kycDetailList.action)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.action &&
													[]
														.concat(viewKycDetailsArray.kycDetailList.action)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Verification ID</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.verificationId &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.verificationId
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.verificationId &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.verificationId
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Request ID</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={6}>{detail.requestId}</Col>;
														})
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray
																.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={6}>{detail.requestId}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Request status</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.regStatus &&
													[]
														.concat(viewKycDetailsArray.kycDetailList.regStatus)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.regStatus &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.regStatus
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Request Date</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.regDate &&
													[]
														.concat(viewKycDetailsArray.kycDetailList.regDate)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.regDate &&
													[]
														.concat(viewKycDetailsArray.kycDetailList.regDate)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Response ID</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.responseId}</Col>;
														})
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray
																.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.responseId}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Verification status</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.verifyStatus &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.verifyStatus
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.verifyStatus &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.verifyStatus
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Verification Description</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.description}</Col>;
														})
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray
																.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.description}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Verification Type</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.docCheckType &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.docCheckType
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.docCheckType &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.docCheckType
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Score</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.fraudScore}</Col>;
														})
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray
																.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.fraudScore}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Recommendation</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.recommendation &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.recommendation
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.recommendation &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.recommendation
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Confidence Level</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return <Col md={4}>{detail.confidenceLevel}</Col>;
														})
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList &&
													[]
														.concat(
															viewKycDetailsArray
																.customerMasterDetailsResponseVO
																.kycAndKybDetailsList
														)
														.map((detail, i) => {
															return (
																<Col md={4}>{detail.confidenceLevel}</Col>
															);
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Verified On</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.customerRegDate &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.customerRegDate
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.customerRegDate &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList
																.customerRegDate
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Verified By</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.verifiedBy &&
													[]
														.concat(viewKycDetailsArray.kycDetailList.verifiedBy)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.verifiedBy &&
													[]
														.concat(
															viewKycDetailsArray.kycDetailList.verifiedBy
														)
														.map((detail, i) => {
															return <Col md={4}>{detail}</Col>;
														})
													: "-"}
											</Col>
										</Row>
									</Col>
								</AccordionDetails>
							</Accordion>
						</div>
						{/* 
            <Typography
              variant="h6"
              component="div"
              className=""
              style={{
                // fontSize: "1.4rem",
                color: "#013c83",
                // marginTop: "20px",
              }}
            >
              Verification Registration Details
            </Typography> */}
						{/* <div>
             

              <Row className="detail-info row">
                <Col md={6}>Action</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.action &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.action)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Verification ID</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.verificationId &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.verificationId)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Request ID</Col>

                {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                  viewKycDetailsArray.customerMasterDetailsResponseVO
                    .kycAndKybDetailsList &&
                  []
                    .concat(
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .kycAndKybDetailsList
                    )
                    .map((detail, i) => {
                      return <Col md={4}>{detail.requestId}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Request status</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.regStatus &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.regStatus)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Request Date</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.regDate &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.regDate)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Response ID</Col>

                {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                  viewKycDetailsArray.customerMasterDetailsResponseVO
                    .kycAndKybDetailsList &&
                  []
                    .concat(
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .kycAndKybDetailsList
                    )
                    .map((detail, i) => {
                      return <Col md={4}>{detail.responseId}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Verification status</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.verifyStatus &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.verifyStatus)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Verification Description</Col>

                {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                  viewKycDetailsArray.customerMasterDetailsResponseVO
                    .kycAndKybDetailsList &&
                  []
                    .concat(
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .kycAndKybDetailsList
                    )
                    .map((detail, i) => {
                      return <Col md={4}>{detail.description}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Verification Type</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.docCheckType &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.docCheckType)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Score</Col>

                {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                  viewKycDetailsArray.customerMasterDetailsResponseVO
                    .kycAndKybDetailsList &&
                  []
                    .concat(
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .kycAndKybDetailsList
                    )
                    .map((detail, i) => {
                      return <Col md={4}>{detail.fraudScore}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Recommendation</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.recommendation &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.recommendation)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Confidence Level</Col>

                {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                  viewKycDetailsArray.customerMasterDetailsResponseVO
                    .kycAndKybDetailsList &&
                  []
                    .concat(
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .kycAndKybDetailsList
                    )
                    .map((detail, i) => {
                      return <Col md={4}>{detail.confidenceLevel}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Verified On</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.customerRegDate &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.customerRegDate)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
              <hr />
              <Row className="detail-info row">
                <Col md={6}>Verified By</Col>

                {viewKycDetailsArray.kycDetailList &&
                  viewKycDetailsArray.kycDetailList.verifiedBy &&
                  []
                    .concat(viewKycDetailsArray.kycDetailList.verifiedBy)
                    .map((detail, i) => {
                      return <Col md={4}>{detail}</Col>;
                    })}
              </Row>
            </div> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Personal Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Person ID:</Col>
											<Col md={6}>
												{viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.personId
													? viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.personId
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>First Name:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.firstName
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.firstName
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Last Name:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.lastName
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.lastName
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Email Id:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.customerEmail
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.customerEmail
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Date Of Birth:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.dob
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.dob
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Phone no:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.mobile
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.mobile
													: "-"}
											</Col>
										</Row>
									</Col>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <Typography
              variant="h6"
              component="div"
              className=""
              style={{
                fontSize: "1.4rem",
                color: "#013c83",
              }}
            >
              Personal Details
            </Typography> */}
						{/* <Row>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Person ID:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.kycDetailList &&
                      viewKycDetailsArray.kycDetailList.personId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>First Name:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.firstName}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Last Name:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.lastName}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Email Id:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.customerEmail}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Date Of Birth:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list && viewKycDetailsArray.list.dob}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Phone no:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.mobile}
                  </Col>
                </Row>
              </Col>
            </Row> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">Address Details</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Address:</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.customerId
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.customerId
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>State:</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.userRole
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.userRole
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>City:</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.entityType
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.entityType
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Zip:</Col>
											<Col md={6}>
												{viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.initiatedBy
													? viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.initiatedBy
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Country Code:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.countryCode
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.countryCode
													: "-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Customer Ip Address:</Col>
											<Col md={6}>
												{viewKycDetailsArray.list &&
													viewKycDetailsArray.list.ipAddress
													? viewKycDetailsArray.list &&
													viewKycDetailsArray.list.ipAddress
													: "-"}
											</Col>
										</Row>
									</Col>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <Typography
              variant="h6"
              component="div"
              className=""
              style={{
                // fontSize: "1.4rem",
                // marginBottom: "1.2rem",
                color: "#013c83",
              }}
            >
              Address Details
            </Typography> */}
						{/* <Row>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Address:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .customerId}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>State:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .userRole}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>City:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .entityType}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Zip:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .initiatedBy}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Country Code:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.customerMasterDetailsResponseVO &&
                      viewKycDetailsArray.customerMasterDetailsResponseVO
                        .initiatedBy}
                  </Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Customer Ip Address:</Col>
                  <Col md={6}>
                    {viewKycDetailsArray.list &&
                      viewKycDetailsArray.list.ipAddress}
                  </Col>
                </Row>
              </Col>
            </Row> */}

						{viewKycDetailsArray.operationList &&
							viewKycDetailsArray.operationList.fileImage ?
							(
								<div
									style={{
										marginTop: "2rem"
									}}
								>
									<Accordion>
										<AccordionSummary
											expandIcon={<ExpandMore />}
											aria-controls="panel1a-content"
											id="panel1a-header"
										>
											<Typography
												style={
													{
														// fontSize: "1.4rem",
													}
												}
												className="themeText"
											>
												Document Details
											</Typography>
										</AccordionSummary>
										<AccordionDetails style={{ display: "unset" }}>
											<Col md={12}>
												<Row className="detail-info row">
													<Col md={6}>File Name:</Col>
													<Col md={6}>
														{viewKycDetailsArray.operationList &&
															viewKycDetailsArray.operationList.fileName
															? viewKycDetailsArray.operationList &&
															viewKycDetailsArray.operationList.fileName
															: "-"}
													</Col>
													{/* <Col sm={12} md={5}>
												{viewKycDetailsRes && viewKycDetailsRes.data && viewKycDetailsRes.data.operationList && viewKycDetailsRes.data.operationList.fileImage && <Card >
													<CardTitle>
														{viewKycDetailsRes.data.operationList.fileName}
													</CardTitle>



													<CardBody>
														<img
															src={`data:image/jpeg;base64,${viewKycDetailsRes.data.operationList.fileImage}`}
															style={{ maxWidth: "100%" }}
														/>
														<br />
														<br />
														<h6 style={{ display: "inline" }}>
															{viewKycDetailsRes.data.operationList.fileName}
														</h6>
														<a
															download={viewKycDetailsRes.data.operationList.fileName}
															href={`data:image/jpeg;base64,${viewKycDetailsRes.data.operationList.fileImage}`}
														>
															<GetAppIcon />
														</a>
													</CardBody>
												</Card>}
											</Col>
											<Col sm={12} md={5}>
												{viewKycDetailsRes && viewKycDetailsRes.data && viewKycDetailsRes.data.kycDetailList && viewKycDetailsRes.data.kycDetailList.selfie && <Card >
													<CardTitle>
														{viewKycDetailsRes.data.kycDetailList.frontPhoto}
													</CardTitle>



													<CardBody>
														<img
															src={`data:image/jpeg;base64,${viewKycDetailsRes.data.kycDetailList.selfie}`}
															style={{ maxWidth: "100%" }}
														/>
														<br />
														<br />
														<h6 style={{ display: "inline" }}>
															{viewKycDetailsRes.data.kycDetailList.frontPhoto}
														</h6>
														<a
															download={viewKycDetailsRes.data.kycDetailList.frontPhoto}
															href={`data:image/jpeg;base64,${viewKycDetailsRes.data.kycDetailList.selfie}`}
														>
															<GetAppIcon />
														</a>
													</CardBody>
												</Card>}
											</Col> */}
												</Row>
												<hr />

												{viewKycDetailsArray.operationList &&
													viewKycDetailsArray.operationList &&
													[]
														.concat(viewKycDetailsArray.operationList)
														.map((img) => (
															<>
																<Row
																	className="detail-info row"
																	style={{ marginBottom: "2rem" }}
																>
																	<Col md={4}>File Image:</Col>
																	<Col md={4}>
																		<img
																			src={`data:image/jpeg;base64,${img.fileImage}`}
																			style={{ maxWidth: "100%" }}
																		/>
																		<br />
																		<br />
																		<h6>{img.fileName}</h6>
																	</Col>
																	<Col md={4}>
																		<a
																			download={img.fileName}
																			href={`data:image/jpeg;base64,${img.fileImage}`}
																		>
																			<GetAppIcon />
																		</a>
																	</Col>
																</Row>
																<hr />
															</>
														))}
												<br />
											</Col>
										</AccordionDetails>
									</Accordion>
								</div>
							) : (
								""
							)
						}



						{viewKycDetailsArray.kycDetailList &&
							viewKycDetailsArray.kycDetailList.verifyStatus == "Approve" && (
								<Row className="detail-info row">
									<Col
										md={12}
										style={{ textAlign: "center", marginTop: "1rem" }}
									>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Approve <ThumbUpIcon />
										</CustomButton>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Reject <ClearIcon />
										</CustomButton>
									</Col>
								</Row>
							)}
						{viewKycDetailsArray.kycDetailList &&
							viewKycDetailsArray.kycDetailList.verifyStatus == "Reject" && (
								<Row className="detail-info row">
									<Col
										md={12}
										style={{ textAlign: "center", marginTop: "1rem" }}
									>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Approve <ThumbUpIcon />
										</CustomButton>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Reject <ClearIcon />
										</CustomButton>
									</Col>
								</Row>
							)}
						{viewKycDetailsArray.kycDetailList &&
							viewKycDetailsArray.kycDetailList.verifyStatus == "Pending" && (
								<Row className="detail-info row">
									<Col
										md={12}
										style={{ textAlign: "center", marginTop: "1rem" }}
									>
										<CustomButton
											style={{
												padding: "8px"
											}}
											onClick={() =>
												handleAcceptOrRejectReq(
													viewKycDetailsArray.kycDetailList.verificationId,
													viewKycDetailsArray.kycDetailList.customerId,
													viewKycDetailsArray.list.userRole,
													viewKycDetailsArray.kycDetailList.fileName,
													viewKycDetailsArray.kycDetailList.action,
													viewKycDetailsArray.kycDetailList.personId,
													"Approve"
												)
											}
										>
											Approve <ThumbUpIcon />
										</CustomButton>
										<CustomButton
											style={{
												padding: "8px"
											}}
											onClick={() =>
												handleAcceptOrRejectReq(
													viewKycDetailsArray.kycDetailList.verificationId,
													viewKycDetailsArray.kycDetailList.customerId,
													viewKycDetailsArray.list.userRole,
													viewKycDetailsArray.kycDetailList.fileName,
													viewKycDetailsArray.kycDetailList.action,
													viewKycDetailsArray.kycDetailList.personId,
													"Reject"
												)
											}
										>
											Reject <ClearIcon />
										</CustomButton>
									</Col>
								</Row>
							)}
					</Box>
				</div>
			</Layout>
		</>
	);
}

export default PartnerViewKycDetails;
